export const Validate = (inputs) => {

    const errors = {};

    if (!inputs.image) {
        errors.image = "Please choose brand logo image";
    }

    if (inputs.image) {

        if (inputs.image.type && inputs.image.type.indexOf('png') === -1 && inputs.image.type.indexOf('jpg') === -1 && inputs.image.type.indexOf('jpeg') === -1) {
            errors.image = "File does not support. You must use .png or .jpg";
        }

    }

    return errors;
}